import { convertHexToRgbA } from '../utils';

export const BACKGROUND = {
	main: '#060606',
	secondary: '#151515',
	snackbar: '#000000',
	input: '#3E3C37',
	modalView: convertHexToRgbA('#292621', 0.8),
	modalViewSecondary: convertHexToRgbA('#171716', 0.8)
};

export const TRANSPARENT = {
	light5: convertHexToRgbA('#ffffff', 0.05),
	light10: convertHexToRgbA('#ffffff', 0.1),
	light15: convertHexToRgbA('#ffffff', 0.15),
	light20: convertHexToRgbA('#ffffff', 0.2),
	light30: convertHexToRgbA('#ffffff', 0.3),
	light45: convertHexToRgbA('#ffffff', 0.45),
	light50: convertHexToRgbA('#ffffff', 0.5),
	light60: convertHexToRgbA('#ffffff', 0.6)
};

export const ICON = {
	main: '#F8FF13',
	secondary: '#7B756B',
	chevron: '#BBB5AA',
	hover: '#575249',
	pressed: '#80796D',
	alwaysWhite: '#ffffff',
	notification: '#FF5E3A',
	warning: '#FBAE27',
	deposit: '#47d7ac'
};

export const CONTROL = {
	primary: '#F8FF13',
	hover: '#DEE500',
	pressed: '#DEE500',
	disabled: '#F7FA85',
	secondary: '#1D1D1E',
	secondaryHover: '#2D2D2F',
	secondaryPressed: '#DEE500',
	dark: '#181818',
	darkHover: '#1D1D1E',
	darkPressed: '#DEE500',
	darkToggle: '#74736F',
	light: '#ffffff',
	lightHover: '#EDEDE9',
	lightPressed: '#DEE500',
	lightToggle: '#B7B7B7'
};

export const TEXT = {
	title: '#FFFFFFCC',
	subtitle: '#DAD6CE',
	body: '#C2BDB2',
	link: '#F8FF13',
	error: '#FF3333',
	warning: '#E2B603',
	alwaysWhite: '#ffffff',
	alwaysDark: '#292621'
};

export const OTHER = {
	calendarDefault: convertHexToRgbA('#000000', 0.6),
	calendarActive: '#5A5A5A',
	calendarBackgroundWhite: convertHexToRgbA('#ffffff', 0.25),
	calendarTextWhite: '#ffffff',
	calendarBackgroundDarkYellow: '#333217',
	calendarTextYellow: '#E2B603',
	calendarBackgroundDarkGreen: '#11362C',
	calendarTextGreen: '#009E69',
	calendarBackgroundDarkPurple: '#3A2159',
	calendarTextPurple: '#AE6FFF',
	calendarBackgroundDarkBlue: '#19334F',
	calendarTextBlue: '#1D92FF'
};

export const TAG = {
	textGreen: '#009E69',
	bgGreen: convertHexToRgbA('#009E69', 0.1),
	textBlue: '#2F8FC7',
	bgBlue: convertHexToRgbA('#2F8FC7', 0.1),
	textYellow: '#E2B603',
	bgYellow: convertHexToRgbA('#E2B603', 0.1),
	textRed: '#FF6964',
	bgRed: convertHexToRgbA('#FF6964', 0.1)
};

export const GAME_TAG_LOGO = {
	dota2Bg: convertHexToRgbA('#FF3333', 0.2),
	dota2Logo: '#FF3333',
	cs2Bg: convertHexToRgbA('#E2B603', 0.15),
	lolBg: convertHexToRgbA('#C79B3B', 0.15),
	lolLogo: '#C79B3B'
};
